import { FC, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { Box, useTheme } from '@mui/material';
import ConnectionsStore from '../stores/connections-store';
import { loadConnections } from '../actions/connections-actions';
import ConnectionItem from '../components/ConnectionItem';
import ConnectionsHeader from '../components/ConnectionsHeader';
import AppSpinner from '../../common/components/AppSpinner';
import ConnectionsLoadError from '../components/ConnectionsLoadError';

const ConnectionsContainer: FC<
  React.PropsWithChildren<ConnectionsContainerProps>
> = props => {
  const theme = useTheme();

  const { isUserAdminRole } = props;
  const { connections, isLoading, errorMessage } =
    useSnapshot(ConnectionsStore);

  useEffect(() => {
    if (connections.length === 0 && !errorMessage) {
      loadConnections();
    }
  }, [connections.length, errorMessage]);

  return (
    <Box gap={theme.spacing(3)} mt={theme.spacing(1)}>
      <ConnectionsHeader />
      {isLoading ? (
        <AppSpinner text='Loading login settings' />
      ) : (
        <>
          {errorMessage ? (
            <ConnectionsLoadError errorMessage={errorMessage} />
          ) : (
            <Box
              display='flex'
              justifyContent='center'
              gap={theme.spacing(3)}
              mt={theme.spacing(10)}>
              {connections.map(c => (
                <ConnectionItem
                  connection={c}
                  isUserAdminRole={isUserAdminRole}
                  key={c.strategy}
                />
              ))}
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export interface ConnectionsContainerProps {
  isUserAdminRole: boolean;
}

export default ConnectionsContainer;
